import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

// eslint-disable-next-line import/prefer-default-export
export const getOpportunityContext = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/opportunities/context/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
